import styled from 'styled-components'

export const PdfViewer = styled.div`
  .pdf {
    height: 800px;
  }
 `